
<template>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :space-between="40"
    :loop="true"
    navigation
    :speed="600"
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    :autoplay="{ delay:4000, disableOnInteraction: false }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <div class="grid">
        <figure><img :src="item.pic" alt="photo"></figure>
        <dl>
          <dt><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg><span v-html="item.title"></span></dt>
          <dd v-html="item.description"></dd>
          <dd><a href="/voices/">ดูผลงานของเรา<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m521.23-480-123 123L440-314.23 605.77-480 440-645.77 398.23-603l123 123Zm-41.16 380q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Z"/></svg></a></dd>
        </dl>
      </div>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.grid{
  display: grid;
  grid-template-columns: 20.5rem 1fr;
  gap: 2rem;
  @media screen and (max-width: module.$phone){
    grid-template-columns: 1fr;
    gap: 0;
  }
  figure{
    img{
      width: 100%;
    }
  }
  dl{
    padding: .8rem 0 0;
    dt{
      font-size: 1.32rem;
      font-weight: 700;
      padding: 0 0 1rem;
      margin: 0 0 1.2rem;
      border-bottom: module.$border 1px solid;
      @include module.flex();
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
      @media screen and (max-width: module.$phone){
        padding: 0 0 .64rem;
        margin: 0 0 .8rem;
        font-size: 1.2rem;
      }
      svg{
        width: 1.72rem;
        display: inline-block;
        fill: module.$org;
        transform: rotateY(180deg);
      }
    }
    dd{
      font-size: .96rem;
      > a{
        display: inline-block;
        color: module.$white;
        background: module.$sub;
        border-radius: .32rem;
        font-size: 1.08rem;
        padding: .4rem 1.6rem;
        padding-right: 3.2rem;
        margin: 1.2rem 0 0;
        position: relative;
        @media screen and (max-width: module.$phone){
          display: block;
          text-align: center;
          font-size: 1.12rem;
          padding: .6rem 1.6rem;
        }
        &:hover{
          background: module.$org;
        }
        svg{
          fill: module.$white;
          width: 1.32rem;
          height: 1.32rem;
          position: absolute;
          top: 50%;
          right: 1.4rem;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
    }
  },
}
</script>
